/**
 * The row shapes the two editors work with, and the only place that mints their ids.
 *
 * `id` is client-side only. It never leaves the browser: `handleSubmit` strips it, and
 * `position` is still derived from the array index server-side (invariant 14). It exists
 * because a sortable list has to be keyed by something stable — key by the array index and
 * React reconciles the wrong row the moment two of them swap, while dnd-kit cannot address
 * the items at all.
 */

export interface IngredientRow {
  id: string
  quantity: string
  unit: string
  name: string
  note: string
  is_optional: boolean
}

export interface StepRow {
  id: string
  text: string
}

export const emptyIngredientRow = (): IngredientRow => ({
  id: crypto.randomUUID(),
  quantity: '',
  unit: '',
  name: '',
  note: '',
  is_optional: false,
})

export const emptyStepRow = (): StepRow => ({ id: crypto.randomUUID(), text: '' })

/** A row id for content arriving from the API, which has never seen one. */
export const newRowId = (): string => crypto.randomUUID()
